import React, { Component } from "react";
import "./assets/css/fonts.scss";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import styled from "styled-components";
import bg from "./assets/img/bg.jpg";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";

import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import reduxPromise from "redux-promise-middleware";
import reducers from "./reducers";

import PageFooter from "./components/layout/PageFooter";
import HomeContent from "./components/pages/HomeContent";
import ContactContent from "./components/pages/ContactContent";
import FeedbackContent from "./components/pages/FeedbackContent";
import GalleryContent from "./components/pages/GalleryContentV2";
import ServicesContent from "./components/pages/ServicesContent";
import ContentWrapper from "./components/layout/ContentWrapper";
import PageHeader from "./components/layout/PageHeader";

const createStoreWithMiddleware = applyMiddleware(reduxPromise())(createStore);

class App extends Component {
  render() {
    return (
      <Provider store={createStoreWithMiddleware(reducers)}>
        <MuiThemeProvider>
          <Router>
            <div className="App" style={{ margin: 0, padding: 0 }}>
              <PageHeader />
              <Container>
                <ContentWrapper>
                  <Switch>
                    <Route exact path="/" component={HomeContent} />
                    <Route exact path="/contact" component={ContactContent} />
                    <Route exact path="/feedback" component={FeedbackContent} />
                    <Route exact path="/gallery" component={GalleryContent} />
                    <Route exact path="/services" component={ServicesContent} />

                    {/* <Route path="*" exact={true} component={PageNotFoundContent} /> */}
                  </Switch>
                </ContentWrapper>
              </Container>
              <PageFooter />
            </div>
          </Router>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

const Container = styled.div`
  width: 100%;
  padding: 20px 0;
  background-image: url(${bg});
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  font-family: "Bree Serif", serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  @media only screen and (max-width: 960px) {
    padding: 20px 0;
  }
`;

export default App;



// WEBPACK FOOTER //
// ./src/App.js